import { MantineThemeOverride } from '@mantine/core';

export type CopyButtonTheme = NonNullable<MantineThemeOverride['components']>['CopyButton'];

export const CopyButton: CopyButtonTheme = {
  // todo: define
};
